/**
 * Map Module for Cloudy
 * Handles map initialization and management
 */

export function initMap(container) {
  if (!container) {
    console.error('Map container not found');
    return;
  }

  // Initialize map (implementation will depend on your map provider)
  try {
    // Example using Mapbox
    const map = new mapboxgl.Map({
      container: container.id,
      style: 'mapbox://styles/mapbox/dark-v10',
      center: [-96.35, 36.91], // Center of US
      zoom: 3.31,
      minZoom: 2,
      maxZoom: 18,
      attributionControl: false,
    });

    // Add navigation controls
    map.addControl(
      new mapboxgl.NavigationControl({
        showCompass: true,
        showZoom: true,
        visualizePitch: true,
      }),
      'top-right'
    );

    // Add attribution
    map.addControl(
      new mapboxgl.AttributionControl({
        compact: true,
      })
    );

    // Add fullscreen control
    map.addControl(new mapboxgl.FullscreenControl());

    // Return the map instance
    return map;
  } catch (error) {
    console.error('Failed to initialize map:', error);
    return null;
  }
}

// Export other map-related functions as needed
export function addMapLayer(map, layerId, layerData) {
  if (!map || !layerId || !layerData) {
    return;
  }

  try {
    if (map.getLayer(layerId)) {
      map.removeLayer(layerId);
    }
    if (map.getSource(layerId)) {
      map.removeSource(layerId);
    }

    map.addSource(layerId, layerData.source);
    map.addLayer(layerData.layer);
  } catch (error) {
    console.error(`Failed to add map layer ${layerId}:`, error);
  }
}

export function removeMapLayer(map, layerId) {
  if (!map || !layerId) {
    return;
  }

  try {
    if (map.getLayer(layerId)) {
      map.removeLayer(layerId);
    }
    if (map.getSource(layerId)) {
      map.removeSource(layerId);
    }
  } catch (error) {
    console.error(`Failed to remove map layer ${layerId}:`, error);
  }
}
